<script lang="ts">
  // BJL-CHECK: Badge (considered, via BusRouteBadge) — rejected here only for the BUS chip:
  // a leg badge stands beside a pixel-sized subway roundel in the same row, and Badge's
  // 'xs'|'sm'|'md' buckets cannot match 22px and 26px, so the two callers collapsed to one
  // chip height and stopped lining up. Everything but the box is still shared
  // (getRouteColor / bulletText), and the subway side is RouteBadge unchanged.
  //
  // The badge for one ride leg: a subway roundel, or the MTA bus blue rounded rect
  // (mirroring BusStopSheet's route badge). Wide bus ids (BxM1, SIM33, B44+) shrink the
  // font instead of overflowing — five characters at the short-id size widen the chip
  // enough to wrap the itinerary's flex leg row onto a second line.
  import { getRouteColor } from '../../ui/colors'
  import { bulletText } from '../../ui/theme'
  import type { BusLeg, SubwayLeg } from '../../services/api'
  import RouteBadge from '../../components/RouteBadge.svelte'

  interface Props {
    leg: SubwayLeg | BusLeg
    size?: number
  }

  const { leg, size = 24 }: Props = $props()
</script>

{#if leg.mode === 'bus'}
  <div
    style="
      height: {size}px; min-width: {size * 1.4}px; padding: 0 {Math.round(size * 0.22)}px;
      border-radius: {Math.round(size / 4)}px; flex-shrink: 0;
      background-color: {getRouteColor(leg.routeId)};
      display: flex; align-items: center; justify-content: center;
    "
  >
    <span
      style="
        {bulletText(leg.routeId, leg.routeId.length <= 3 ? size * 0.44 : size * 0.34)};
        letter-spacing: 0.2px;
      "
    >{leg.routeId}</span>
  </div>
{:else}
  <RouteBadge routeId={leg.routeId} {size} />
{/if}
